import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "../ui/dialog";

/**
 * AvatarLightbox — click-to-enlarge profile photo preview.
 *
 * Renders a clean, dark-background dialog with the photo centered and
 * uncropped. The user closes by clicking outside, hitting ESC, or via
 * the built-in dialog close button.
 */
export default function AvatarLightbox({ open, onOpenChange, src, alt }) {
  if (!src) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-2xl bg-slate-950 border-slate-800 p-2"
        data-testid="avatar-lightbox"
      >
        <DialogTitle className="sr-only">{alt || "Profile photo preview"}</DialogTitle>
        <div className="flex items-center justify-center min-h-[300px]">
          <img
            src={src}
            alt={alt || "Profile photo"}
            className="max-h-[75vh] w-auto rounded-lg object-contain"
            data-testid="avatar-lightbox-img"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
